import { render, staticRenderFns } from "./business_line.vue?vue&type=template&id=47b8bd4b&scoped=true"
import script from "./business_line.vue?vue&type=script&lang=js"
export * from "./business_line.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b8bd4b",
  null
  
)

export default component.exports